import { LeftNav } from '../layouts/Base';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../providers/AuthContext';
import { useDataManagerAccess } from '../hooks/useDataManagerAccess';
import {
    DATA_MANAGER_HOME,
    DATA_MANAGER_WORKSPACE_LABEL,
    getVisibleDataManagerSteps,
} from '../constants/setupRoadmapSteps';

function Manage() {
    const { user } = useAuth();
    const { isDataManager } = useDataManagerAccess();
    const isAdmin = !!user?.admin;

    const dataChildren = getVisibleDataManagerSteps().map((step) => ({
        text: step.title,
        to: step.route,
    }));

    const navLinks = [
        { text: 'Home', to: '/' },
        {
            text: DATA_MANAGER_WORKSPACE_LABEL,
            to: DATA_MANAGER_HOME,
            children: dataChildren,
        },
    ];

    if (isAdmin) {
        navLinks.push(
            { text: 'Schemas', to: '/manage/schema' },
            { text: 'Schema Wrangler', to: '/manage/wrangler' },
            { text: 'Schema Viewer', to: '/manage/schema-viewer' },
            { text: 'Administrator tools', to: '/admin' },
        );
    }

    if (!isDataManager && !isAdmin) {
        return (
            <div><h2>Please log in as a Data Manager or administrator to view this page</h2></div>
        );
    }

    return (
        <>
        <LeftNav navLinks={navLinks}>
            <Outlet/>
        </LeftNav>
        </>
    )
}

export default Manage;
